// components
import Footer from "components/Footer";
import { NavbarAndSidebar } from "components/NavbarAndSidebar";
import { useEffect } from "react";
import MetaTags from "react-meta-tags";
// styles
import "./style.scss";

const JoinUsPage = () => {
	// scroll to top of the page
	useEffect(() => {
		document.documentElement.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	return (
		<>
			<MetaTags>
				<title> Join Us | SaffronStays</title>
			</MetaTags>
			<NavbarAndSidebar />
			<div className="JoinUs-wrapper">
				<div className="join-us-card">
					<h1>Join Us</h1>
					<p>
						We are a fast-paced startup where change is the only constant. Roles
						evolve, challenges keep you on your toes, and every day is an
						opportunity to create something meaningful.
					</p>
					<p>
						We don’t hire just for skills. We seek hustle, passion, and a growth
						mindset. If you’re looking for predefined roles and comfort zones,
						we might not be the right fit. But if the thrill of building
						something from the ground up, rapid growth, and limitless
						opportunities excites you, we’d love to have you on board.
					</p>
					<p>
						Intrapreneurs thrive in our ecosystem. We have a clear path to
						becoming a Co-Founder, unlocking leadership opportunities for those
						who step up. This isn’t a mom-and-pop shop. It’s a professional,
						structured setup built for scale.
					</p>
					<p>
						Agility doesn’t come at the cost of fairness. We take reward,
						recognition, and compensation as seriously as we do our vision. Our
						HR processes rival those of companies 10x our size, ensuring that
						every contribution is valued. We set ambitious goals through
						meticulously planned OKRs, guiding both the company’s growth and
						your own.
					</p>
					<p>
						We take pride in our genuine hybrid work environment. Whether it’s
						collaborating in the office, deep work at home, or creative
						brainstorming at our villas, we can agree on the setting that best
						suits your role.
					</p>
					<p>
						We recognize that we don’t have all the facts or answers to every
						question, but the single trait we value most in our people is{" "}
						<strong>“figureoutability.”</strong> This means having the ability
						to find solutions to challenges encountered. Along with that, we
						prioritize <strong>speed of execution over perfection</strong>—this
						defines the SaffronStays DNA.
					</p>
					<p>
						So respond to the posts below, or write to{" "}
						<a href="mailto:iamjarvis@saffronstays.com">
							iamjarvis@saffronstays.com
						</a>{" "}
						with your resume, the role that interests you, and why you would
						like to join us.
					</p>
				</div>
				<div className="join-us-img">
					<img
						src="https://ik.imagekit.io/5tgxhsqev/saffronstays-media/image/upload/ss3/Business_merger-cuate_2"
						alt="#"
					/>
				</div>
			</div>
			{/* <!-- Elfsight Job Board | Careers - Job Openings --> */}
			<script
				src="https://static.elfsight.com/platform/platform.js"
				async
			></script>
			<div
				className="elfsight-app-926564cb-1ecf-4658-807a-b81ebcd76875"
				data-elfsight-app-lazy
			></div>
			<Footer />
		</>
	);
};

export default JoinUsPage;
